/*
 * React mixin for streamlining the spin.js usage
 */

import Spinner from 'spin.js';
import _ from 'underscore';

import './index.scss';

export const DEFAULT_OPTS = {
  lines: 14,
  length: 0,
  width: 5,
  radius: 27,
  corners: 0.8,
  rotate: 30,
  trail: 36,
  speed: 1.2,
  direction: 1,
  hwaccel: true,
};

export const SpinnerHelper = {
  initSpinner() {
    this.spinner = new Spinner(
      _.extend({}, DEFAULT_OPTS, this.spinnerOptions && this.spinnerOptions())
    ).spin(this.spinnerTarget());
  },

  showSpinner() {
    if (this.spinner) {
      this.spinner.spin(this.spinnerTarget());
    } else {
      this.initSpinner();
    }
  },

  hideSpinner() {
    if (this.spinner) {
      this.spinner.stop();
    }
  },

  componentWillUnmount() {
    this.hideSpinner();
  },
};
